<template>
  <CRow>
    <CCol col="12">
      <CCard v-if="itemData">
        <CCardHeader> الحجز رقم: {{ $route.params.id }} </CCardHeader>
        <CCardBody>
          <CAlert color="info">
            <CRow>
              <CCol col="3">حالة الحجز</CCol>
              <CCol col="3"> {{ itemData.status_name }} </CCol>
            </CRow>
          </CAlert>
          
          <CAlert color="info">
            <CRow>
              <CCol col="3">المحامي</CCol>
              <CCol col="3"> {{ itemData.lawyer_name }} </CCol>
            </CRow>
          </CAlert>
          
          <CAlert color="info">
            <CRow>
              <CCol col="3">موبايل المحامي</CCol>
              <CCol col="3"> {{ itemData.lawyer_phone }} </CCol>
            </CRow>
          </CAlert>
          
          <CAlert color="info">
            <CRow>
              <CCol col="3">العميل</CCol>
              <CCol col="3"> {{ itemData.client_name }} </CCol>
            </CRow>
          </CAlert>
          
          <CAlert color="info">
            <CRow>
              <CCol col="3">موبايل العميل</CCol>
              <CCol col="3"> {{ itemData.client_phone }} </CCol>
            </CRow>
          </CAlert>

          <CAlert color="info">
            <CRow>
              <CCol col="3"> المكتب </CCol>
              <CCol col="3"> {{ itemData.office_name }} </CCol>
            </CRow>
          </CAlert>
          
          <CAlert color="info">
            <CRow>
              <CCol col="3"> السعر الاساسي </CCol>
              <CCol col="3"> {{ itemData.sub_price }} </CCol>
            </CRow>
          </CAlert>
          
          <CAlert color="info">
            <CRow>
              <CCol col="3"> السعر النهائي </CCol>
              <CCol col="3"> {{ itemData.final_price }} </CCol>
            </CRow>
          </CAlert>
          
          <CAlert color="info">
            <CRow>
              <CCol col="3"> ميعاد الحجز </CCol>
              <CCol col="3"> {{ itemData.booking_at }} </CCol>
            </CRow>
          </CAlert>
          
          <CAlert color="info">
            <CRow>
              <CCol col="3"> طريقة الدفع </CCol>
              <CCol col="3"> {{ itemData.payment_method }} </CCol>
            </CRow>
          </CAlert>
          
        </CCardBody>
        <CCardFooter>
          <CButton color="info" @click="goBack">رجوع</CButton>
        </CCardFooter>
      </CCard>
      <Spinner v-else />
    </CCol>
  </CRow>
</template>

<script>
// import bookingsData from "./BookingsData";
export default {
  name: "Booking",
  data() {
    return {
      itemData: null,
      bookingsOpened: null,
    };
  },
  created() {
    this.getBooking();
  },
  methods: {
    getBooking() {
      this.toggleLoadSpinner();

      this.$http
        .get("bookings/" + this.$route.params.id)
        .then((res) => {
          // handle success
          this.itemData = res.data.data;
          this.toggleLoadSpinner();
        })
        .catch((error) => {
          //
          this.toggleLoadSpinner();
        });
    },
    toggleLoadSpinner() {
      this.$store.commit("toggleLoadSpinner");
    },
    goBack() {
      this.bookingsOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/bookings" });
    },
    getBadge(status) {
      switch (status) {
        case "Active":
          return "success";
        case "Inactive":
          return "secondary";
        case "Pending":
          return "warning";
        case "Banned":
          return "danger";
        default:
          "primary";
      }
    },
  },
};
</script>
